import { render, staticRenderFns } from "./LicencePopup.vue?vue&type=template&id=121762b2&"
import script from "./LicencePopup.vue?vue&type=script&lang=js&"
export * from "./LicencePopup.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports